export default "__VITE_ASSET__BYiUvc3w__"